@use '../../../scss/settings/colors' as colors;

.checkbox_font {
  margin-top: 20px;
  color: colors.$dark-blue;
  font-family: 'Medium Inter', sans-serif;
}

.card_content_min_height {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 213px;
}

.typography {
  color: colors.$gray-variant-19;
  margin-left: 0.5rem;
}

.card_border_bottom{
  border-bottom: 2px solid colors.$gray-variant-4;
}

.notes_card {
  display: flex;
  justify-content: 'space-between';
}

.card {
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out, border 0.2s ease-in-out;
  transform: scale(1);
}

.card_border {
  border: 1px solid colors.$brand-purple;
  animation: pulse 0.4s ease-in-out;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

.add_button_size {
  width: 40px !important;
  height: 40px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  flex-shrink: 0;
}
